

import { useState, useEffect } from "react"
import { FaCheck, FaTimes } from "react-icons/fa"
import { useAppContext } from "../context/AppContext"
import "./ShiftModal.css"
import { Link } from "react-router-dom"

const ShiftModal = ({ isOpen, onClose, selectedDate, shift = null }) => {
  const { tags, addShift, updateShift, deleteShift, markShiftAsPaid } = useAppContext()

  const d = selectedDate.split("-")
  const [tagId, setTagId] = useState("")
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const [paid, setPaid] = useState(false)
  const [errors, setErrors] = useState({})
  const [markHora, setMarkHora] = useState(false)
  const [value, setValue] = useState(0)

  useEffect(() => {
    if (shift) {
      const selectedTag = tags.find((tag) => tag.id === shift.tagId)

      

      setTagId(shift.tagId)
      setValue(shift.value ? shift.value : selectedTag.paymentAmount)
      setStartTime(shift.startTime)
      setEndTime(shift.endTime)
      setPaid(shift.paid)
      setMarkHora(shift.time)
    }
  }, [shift])

  const handleTagChange = (e) => {
    const newTagId = e.target.value
    setTagId(newTagId)

    // Set default times from the selected tag
    if (newTagId && !shift) {
      const selectedTag = tags.find((tag) => tag.id === newTagId)
      if (selectedTag) {
        setMarkHora(selectedTag.time)
        setStartTime(selectedTag.defaultStartTime)
        setEndTime(selectedTag.defaultEndTime)

      }
    }
  }

  const validate = () => {
    const newErrors = {}

    if (!tagId) {
      newErrors.tagId = "Selecione uma etiqueta"
    }

    if (!startTime) {
      newErrors.startTime = "O horário de início é obrigatório"
    }

    if (!endTime) {
      newErrors.endTime = "O horário de término é obrigatório"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validate()) {
      const shiftData = {
        tagId,
        date: selectedDate,
        startTime,
        endTime,
        paid,
        time: markHora,
        value: +value
      }

      if (shift) {
        updateShift(shift.id, { ...shift, ...shiftData })
      } else {
        addShift(shiftData)
      }

      onClose()
    }
  }

  const handleDelete = () => {
    if (window.confirm("Tem certeza que deseja excluir este plantão?")) {
      deleteShift(shift.id)
      onClose()
    }
  }

  const handleMarkAsPaid = () => {
    markShiftAsPaid(shift.id)
    setPaid(true)
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>{shift ? "Editar Plantão" : "Adicionar Plantão"}</h2>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Data</label>
              <input
                type="text"
                className="form-control"
                value={`${d[2]}/${d[1]}/${d[0]}`}
                disabled
              />
            </div>

            <div className="form-group">
              <label className="form-label">Etiqueta</label>
              <select
                className={`form-control ${errors.tagId ? "is-invalid" : ""}`}
                value={tagId}
                onChange={handleTagChange}
              >
                <option value="">Selecione uma etiqueta</option>
                {tags.map((tag) => (
                  <option key={tag.id} value={tag.id}>
                    {tag.name}
                  </option>
                ))}
              </select>
              {errors.tagId && <div className="invalid-feedback">{errors.tagId}</div>}

              {tags.length === 0 && <div className="no-tags-warning">Você precisa criar etiquetas primeiro. <Link to="/tags">Criar agora</Link> </div>}
            </div>

            <div className="form-group">
              <label className="form-label">Valor</label>
                <input className="form-control" value={value} onChange={e => setValue(e.target.value)} type="number"/>
                
            </div>

            <div className="checkbox-container">
              <input type="checkbox" onChange={(e) => setMarkHora(e.target.checked)} value={markHora} checked={markHora} id="markHora" />
              <label htmlFor="markHora">Marcar Hora</label>
            </div>

            {markHora && (


              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Horário de Início</label>
                  <input
                    type="time"
                    className={`form-control ${errors.startTime ? "is-invalid" : ""}`}
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                  />
                  {errors.startTime && <div className="invalid-feedback">{errors.startTime}</div>}
                </div>

                <div className="form-group">
                  <label className="form-label">Horário de Término</label>
                  <input
                    type="time"
                    className={`form-control ${errors.endTime ? "is-invalid" : ""}`}
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                  />
                  {errors.endTime && <div className="invalid-feedback">{errors.endTime}</div>}
                </div>
              </div>
            )}

            <div className="form-group">
              <div className="checkbox-container">
                <input type="checkbox" id="paid" checked={paid} onChange={(e) => setPaid(e.target.checked)} />
                <label htmlFor="paid">Marcado como pago</label>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            {shift && (
              <div className="modal-actions-left">
                <button type="button" className="btn btn-danger" onClick={handleDelete}>
                  Excluir
                </button>

                {!shift.paid && (
                  <button type="button" className="btn btn-success" onClick={handleMarkAsPaid}>
                    <FaCheck className="icon-left" /> Marcar como Pago
                  </button>
                )}
              </div>
            )}

            <div className="modal-actions-right">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancelar
              </button>

              <button type="submit" className="btn btn-primary">
                {shift ? "Salvar" : "Adicionar"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ShiftModal

